import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TAG_DETAIL_PAGE_LAYOUT_TYPE } from '../../../../constants/service/app/tagConstants';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import TagPreviewModal from '../../../../views/app/common/modal/PreviewTagDetailModal';

class PreviewTagDetailModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tagDetailLayoutType: TAG_DETAIL_PAGE_LAYOUT_TYPE.GALLERY,
    };
  }

  /**
   *  태그 상세 페이지 레이아웃 변경
   */
  changeTagDetailLayoutType = (tagDetailLayoutType) => {
    this.setState({
      tagDetailLayoutType,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'tagPreviewModal', value: false });
  };

  render() {
    return (
      <TagPreviewModal
        {...this.state}
        {...this.props}
        changeTagDetailLayoutType={this.changeTagDetailLayoutType}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.tagPreviewModal.isOpen,
    data: state.app.tagPreviewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PreviewTagDetailModalContainer));
